<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/acquisition.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-5">
                <h4 class="primary-color font-600">
                  {{ $t("text.bSales.productSales") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.bSales.managePS") }}
                </p>
              </div>
              <div class="col-md-6 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.bSales.totSales") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/acquisition.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ salesCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div>
            <div>
              <h4 class="deep-grey bold-span">
                {{ $t("text.bProductReceived.totalVolume") }}
              </h4>
            </div>
            <div class="">
              <h4>
                <span class="currency"></span
                ><span class="amount-figures"
                  >{{ convertThousand(totalVolume) }} </span
                ><span class="grey-text bold-span">{{
                  $t("text.units.litres")
                }}</span>
              </h4>
            </div>
            <div class="grey-text"></div>
          </div>
          <div class="text-right">
            <div>
              <h4 class="deep-grey bold-span">
                {{ $t("text.payments.totalAmount") }}
              </h4>
            </div>
            <div>
              <h4 class="currency">
                <span class="amount-figures">{{
                  convertThousand(totalAmount)
                }}</span>
                <span class="grey-text bold-span">{{
                  branch ? branch.currency : ""
                }}</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div class="price_change_input_wrapper w-25 mr-5">
            <vue-ctk-date-time-picker
              id="DateTimePicker"
              v-model="dateRange.startDate"
              color="#4b2d73"
              :locale="this.$root.$i18n.locale"
              format="YYYY-MM-DD h:mm a"
              formatted="DD/MM/YYYY h:mm a"
              :label="$t('text.dealers.selectDate')"
              @is-hidden="getHiddenState"
            />
          </div>
          <div class="price_change_input_wrapper w-25 mr-5">
            <vue-ctk-date-time-picker
              id="DateTimePicker1"
              v-model="dateRange.endDate"
              color="#4b2d73"
              :locale="this.$root.$i18n.locale"
              format="YYYY-MM-DD h:mm a"
              formatted="DD/MM/YYYY h:mm a"
              :label="$t('text.dealers.selectEndDate')"
            />
          </div>
          <div class="w-25">
            <div class="price_change_input_wrapper">
              <select v-model="product">
                <option value="select product" disabled>
                  {{ $t("text.iAddOrder.selectAProduct") }}
                </option>
                <option
                  :value="prod"
                  v-for="(prod, index) in prodArray"
                  :key="index"
                >
                  {{ prod }}
                </option>
              </select>
            </div>
          </div>
          <div class="w-25 text-right">
            <button class="btn btn-info" @click="() => getProductSales()">
              {{ $t("text.actionButtons.submit") }}
            </button>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <!-- :format="formatOptions"
                  type="date" -->
                <e-column
                  width="250"
                  field="date"
                  :headerText="$t('text.bSales.dateSold')"
                ></e-column>
                <e-column
                  width="150"
                  field="openingRead"
                  :headerText="$t('text.bSales.openingRead')"
                  format="N2"
                ></e-column>
                <e-column
                  width="150"
                  field="closingRead"
                  :headerText="$t('text.bSales.closingRead')"
                  format="N2"
                ></e-column>
                <e-column
                  width="150"
                  field="totalSale"
                  :headerText="$t('text.bSales.vol')"
                  format="N2"
                ></e-column>
                <e-column
                  width="150"
                  field="amount"
                  :headerText="$t('text.bSales.amt')"
                ></e-column>
                <e-column
                  width="150"
                  field="priceSold"
                  :headerText="$t('text.bSales.priceSold')"
                  format="N2"
                ></e-column>
                <e-column
                  width="120"
                  field="pumpName"
                  :headerText="$t('text.bSales.nozzle')"
                ></e-column>
                <e-column
                  width="150"
                  field="transactionType"
                  :headerText="$t('text.bSales.transactionType')"
                  format="N2"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import UserStatusTemp from "@/components/Templates/userStatusTemp";
import AddOldUserModal from "@/components/modals/addOldUser";
import Template from "@/components/Templates/NonWetProducts/sales";
import Paginator from "@/components/Paginator.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Non Wet Products Sales :: Epump Portal",
  name: "NonWetProductSales",
  components: {
    MasterLayout,
    TableLoader,
    AddOldUserModal,
    Paginator,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // dateRange: {
      //   startDate: this.$moment("2025-06-29 15:00", "YYYY-MM-DD HH:mm").format(
      //     "YYYY-MM-DD h:mm a"
      //   ),
      //   endDate: this.$moment("2025-06-29 16:00", "YYYY-MM-DD HH:mm").format(
      //     "YYYY-MM-DD h:mm a"
      //   ),
      // },
      dateRange: {
        startDate: this.$moment().format("YYYY-MM-DD h:mm a"),
        endDate: this.$moment().format("YYYY-MM-DD h:mm a"),
      },
      salesCount: 0,
      showLoader: true,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      branch: null,
      sortType: "",
      sortColumn: "",
      searchValue: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      tableCount: 0,
      prodArray: [],
      product: "PMS",
      totalVolume: 0,
      totalAmount: 0,
    };
  },
  watch: {
    branch: function (newBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getProducts();
          this.getProductSales();
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `product sales report :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.getProductSales.totalNumber / pageSize);
      this.getProductSales();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getProductSales();
    },
    actionHandler: function (args) {
      if (args.requestType == "sorting") {
        if (args.direction) {
          this.sortType = args.direction;
          this.sortColumn = args.columnName;
        } else {
          this.sortType = "";
          this.sortColumn = "";
        }
        this.getProductSales();
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Vehicles.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.prodArray = response.data.map((prod) => {
            return prod.name;
          });
          this.product = this.prodArray[0];
          this.getProductSales();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    rowDataBound: function (args) {
      if (args.data["status"] === "Active") {
        args.row.cells[4].style.color = "green";
      }
      if (args.data["status"] === "Deactivated") {
        args.row.cells[4].style.color = "blue";
      }
      if (args.data["status"] === "Suspended") {
        args.row.cells[4].style.color = "red";
      }
    },
    datesAreOnSameDay(first, second) {
      if (
        first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate()
      ) {
        return true;
      }
      return false;
    },
    getProductSales() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Report/ProductSales/${
            this.branch.id
          }?startDate=${this.dateRange.startDate}&endDate=${
            this.dateRange.endDate
          }&PageNumber=${this.currentPage}&PageSize=${this.pageSize}&product=${
            this.product === "select product" ? "" : this.product
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.salesCount = response.data.data.length;
          let index = 0 + (this.currentPage - 1) * this.pageSize;
          response.data.data.forEach((el) => {
            el.index = ++index;
            el.date = this.$moment(el.date).utc().format("YYYY-MM-DD, hh:mm a");
          });
          this.totalVolume = response.data.data.reduce(
            (acc, cur) => (acc += cur.totalSale),
            0
          );
          this.totalAmount = response.data.data.reduce(
            (acc, cur) => (acc += cur.amount),
            0
          );
          this.salesCount = response.data.totalNumber;
          this.totalPages = Math.ceil(
            response.data.totalNumber / this.pageSize
          );
          this.tableCount = response.data.totalNumber;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
